var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[(_vm.canBack)?_c('div',{staticClass:"header-icon",on:{"click":function($event){return _vm.goBack()}}},[_c('span',{staticClass:"iconfont icon-fanhui"})]):_vm._e(),_c('div',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.canBack)?_c('div',{staticClass:"empty-class"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }